export default "__VITE_ASSET__DsCuwKvD__"